exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".clc6i{padding-top:30px}._2NJZD,.clc6i{margin:0 auto;max-width:1080px}._2NJZD{width:100%;display:block}.qCjZl{margin-top:24px}.qh6xp{text-align:right}._3gyPZ{text-align:left}._6qRdX{text-align:center}._36XlU{padding:0}._1embi{border-color:#ff7e82;background-color:#ff7e82;color:#fff;float:right;font-size:16px}._1embi:hover{background:rgba(54,50,119,.8)}._1embi:focus{border-color:#0074c2;box-shadow:0 0 8px rgba(0,116,194,.6)}.XWmd5{border-color:#ff5a5f;background-color:#ff5a5f;color:#fff}._4N7SZ{padding:9px 27px}.XWmd5:active,.XWmd5:active:focus,.XWmd5:active:hover,.XWmd5:focus,.XWmd5:hover{border-color:#ff7e82;background-color:#ff7e82;color:#fff}._ma17{border-color:#ff5a5f;color:#ff5a5f;background-color:#fff}._ma17:active,._ma17:active:focus,._ma17:active:hover,._ma17:focus,._ma17:hover{border-color:#ff7e82;color:#ff7e82;background-color:#fff}._1Am5U{padding:5px 0}.VNeYq{border-radius:0;width:100%;display:block;color:#484848;font-size:16px;padding-bottom:12px;border-bottom:1px solid #dce0e0}._3jckZ{margin-bottom:6px}.XygzN{padding:10px 35px 10px 10px}._3w7pi,.XygzN{height:40px;border-radius:4px;font-size:14px;border:1px solid #d9d9d9;background-color:#fff;color:#484848;font-weight:400}._3w7pi{padding:10px 32px 10px 10px}._2kbp5{position:relative;display:inline-block;vertical-align:bottom;margin-right:5px}._18UA_{overflow:hidden}._1W3e0{font-size:16px;color:#484848;margin:6px 0}._7RKsr{font-size:14px;color:#767676;margin:6px 0;line-height:1.43;font-weight:400}._6OO3F{color:#008489}._1YvxB{font-size:16px;line-height:32px}._6OO3F:focus,._6OO3F:hover{color:#008489;text-decoration:underline}@media screen and (max-width:768px){._3aanJ{padding:0}}@media screen and (max-width:640px){._16tkr{margin-bottom:18px}}", ""]);

// exports
exports.locals = {
	"container": "clc6i",
	"landingContainer": "_2NJZD",
	"spaceTop4": "qCjZl",
	"textAlignRight": "qh6xp",
	"textAlignLeft": "_3gyPZ",
	"textAlignCenter": "_6qRdX",
	"noPadding": "_36XlU",
	"button": "_1embi",
	"btnPrimary": "XWmd5",
	"btnlarge": "_4N7SZ",
	"btnPrimaryBorder": "_ma17",
	"btnSmall": "_1Am5U",
	"panelHeader": "VNeYq",
	"formGroup": "_3jckZ",
	"formControlInput": "XygzN",
	"formControlSelect": "_3w7pi",
	"select": "_2kbp5",
	"formSection": "_18UA_",
	"captionText": "_1W3e0",
	"labelText": "_7RKsr",
	"modalCaptionLink": "_6OO3F",
	"modalCaptionLinkLarge": "_1YvxB",
	"smPadding": "_3aanJ",
	"smBottom": "_16tkr"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/editProfile/EditProfile.css
// module id = 2620
// module chunks = 15